import React, { useState, useEffect } from "react";

const Footer = () => {
  const [data, setData] = useState(null);
    
  useEffect(() => {
    fetch('db/general.json')
      .then(response => response.json())
      .then(parsedData => {
        setData(parsedData); 
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <footer id="footer" className="section bg-dark text-white">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start wow fadeInUp">
            <p className="mb-2 mb-lg-0">
              Copyright © 2024{" "}
              <a className="fw-600" href="/">
                {data ? data.name : ""}
              </a>
              . All Rights Reserved.
            </p>
          </div>
          {/* <div className="col-lg-6 wow fadeInUp">
            <p className="mb-0 text-center text-lg-end">
              Designed by{" "}
              <a className="fw-600" href="https://www.harnishdesign.net/">
                Harnish Design
              </a>
            </p>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
